export default __webpack_public_path__ + "media/images/badge-level3-size16-3c75391bb7408cf382ed398c60418f50.png";